import { render } from "./SlideMenu.vue?vue&type=template&id=49771236"
import script from "./SlideMenu.vue?vue&type=script&lang=js"
export * from "./SlideMenu.vue?vue&type=script&lang=js"

import "./SlideMenu.vue?vue&type=style&index=0&id=49771236&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__